<template>
  <div class="workshop" v-if="clientList.length">
    <div class="workshop-list green-shadow" v-for="(clientItem, index) in clientList" :key="index">
      <van-image class="workshop-item-img" :src="clientItem.img"></van-image>
      <div class="workshop-item-content">
        <p class="workshop-name">{{ clientItem.clientName }}</p>
        <p class="row color-999">
          <span v-for="pointItem in clientItem.pointList" :key="pointItem.pointType">{{ pointItem.pointTypeName
          }}:{{ pointItem.pointValue }}</span>
        </p>
        <p class="row workshop-address">
          <span class="color-999 ">{{ clientItem.detailAddress }}</span>
          <van-button type="primary" size="small" round @click="handleShowPage(clientItem)">授权绑定</van-button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    clientList: {
      type: Array,
      default: () => {
        return []
      }
    },
    kongzTokenDTO: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    // 选择修理厂
    handleShowPage (item) {
      this.$emit('selectItem', item)
    }
  }
}
</script>
<style  scoped lang="less">
.workshop {
  padding: 0.4rem;
  background-color: rgb(246, 250, 250);

  .workshop-list {
    background-color: #fff;
    display: flex;
    height: auto;
    font-size: 0.35rem;
    padding: 0.3rem;
    align-items: center;
    border-radius: 10px;
    margin-bottom: 0.4rem;

    .workshop-item-img {
      width: 2rem;
      height: 2rem;
      flex-shrink: 0;

      /deep/ .van-image__img {
        border-radius: 10px;
      }

      /deep/ .van-image__img {
        border-radius: 10px;
      }

      /deep/ .van-image__loading {
        border-radius: 10px;
      }
    }

    .workshop-item-content {
      min-height: 2rem;
      height: auto;
      flex: 1 1 auto;
      margin-left: 0.4rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .workshop-name {
        font-size: 0.4rem;
        font-weight: 600;
      }

      .workshop-address {
        align-items: flex-end;

        button {
          white-space: nowrap;
          padding: 0.1rem 0.15rem;
          height: 100%;
        }
      }
    }
  }
}
.row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.color-999 {
  color: #999;
  font-size: 0.3rem;
}
</style>
